import {Pipe, PipeTransform} from '@angular/core';
import {CustomerModel} from '../models/customer.model';

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {

    transform(customers: CustomerModel[], text: string): CustomerModel[] {
        if (text.length === 0) {
            return customers;
        }

        text = text.toLowerCase();

        return customers.filter(customer => {
            const id = '' + customer.id;
            return customer.name.toLowerCase().includes(text) || customer.cod.toLowerCase().includes(text) || id.includes(text);
        });

    }

}
